import { AdvertisementType } from "@/common/types"
import AdvertisementCard from "@/components/admin/AdvertisementCard"
import SlotForm from "@/components/advertisements/SlotForm"
import CreateAdvertisementDialog from "@/dialogs/advertisements/CreateAdvertisementDialog"
import useListAdvertisements from "@/hooks/api/advertisements/useListAdvertisements"
import useListAdvertisementSlots from "@/hooks/api/advertisements/useListAdvertisementSlots"
import useDialogState from "@/hooks/useDialogState"
import { Box, Button, Stack } from "@mui/material"

export const ManageAdvertisements = () => {
  const { data: advertisements, isLoading } = useListAdvertisements({
    filters: { filterValue: "" },
  })
  const { data: advertisementSlots, isLoading: slotsIsLoading } =
    useListAdvertisementSlots()
  const { openDialog, ...dialogState } = useDialogState({})

  if (isLoading || slotsIsLoading) {
    return <>Loading...</>
  }

  const largeImageOptions = advertisements.data
    .filter((advert: AdvertisementType) => advert.large_image !== null)
    .map((advertisement: AdvertisementType) => {
      return {
        label: advertisement.company_name,
        value: String(advertisement.advertisement_id),
      }
    })
  const smallImageOptions = advertisements.data
    .filter((advert: AdvertisementType) => advert.small_image !== null)
    .map((advertisement: AdvertisementType) => {
      return {
        label: advertisement.company_name,
        value: String(advertisement.advertisement_id),
      }
    })
  const mobileImageOptions = advertisements.data
    .filter((advert: AdvertisementType) => advert.mobile_image !== null)
    .map((advertisement: AdvertisementType) => {
      return {
        label: advertisement.company_name,
        value: String(advertisement.advertisement_id),
      }
    })

  largeImageOptions.unshift({ label: "None", value: "null" })
  smallImageOptions.unshift({ label: "None", value: "null" })
  mobileImageOptions.unshift({ label: "None", value: "null" })

  return (
    <Box>
      <Box display="flex" paddingY={4}>
        <Button variant="contained" onClick={openDialog}>
          Create Advertisement
        </Button>
      </Box>
      <Stack>
        {advertisements.data.map((advertisement: AdvertisementType) => (
          <AdvertisementCard
            key={advertisement.advertisement_id}
            advertisement={advertisement}
          />
        ))}
      </Stack>
      {/* assign advertisements to slots */}
      <Stack width="100%">
        <SlotForm
          advertisementSlots={advertisementSlots.data}
          largeImages={largeImageOptions}
          smallImages={smallImageOptions}
          mobileImages={mobileImageOptions}
        />
      </Stack>
      <CreateAdvertisementDialog {...dialogState} />
    </Box>
  )
}
